import { useUserIdentity } from '@src/stores-v2/StoreContext';
import { createRef, useState } from 'react';
import styled from 'styled-components';

import { AspectRatio } from '../../../types.ts/video';
import {
  getPosterUrl,
  getShareableImageDimension,
} from '../../../utility/general';
import { useFlagsCombination } from '../../../utility/useFlagsCombination';
import ShareableImageView from '../../common/ShareableImageView';
import DimensionsSelector from '../DimensionsSelector';
import ShareModal from '../ShareModal';
import SocialShareStatus from '../SocialShareStatus';

import type {
  Artifact,
  Caption,
  ShareableImagePreviewType,
  ShareableImageType,
  SharedContent,
} from '../../../types.ts/story';
import type { Dispatch, SetStateAction } from 'react';

type Props = {
  sharablePost: {
    id: string;
    quote: string;
    storytellerName?: string;
    imagefile?: Artifact;
    _allReferencingSharedContents?: SharedContent[];
    _allReferencingCaptions?: Caption[];
  };
  toggleShare: Dispatch<SetStateAction<ShareableImageType | null>>;
};

const SharableImagesModalOLD = (props: Props) => {
  const userIdentity = useUserIdentity();
  const imageRef = createRef<HTMLImageElement>();
  const [currDimension, setCurrDimension] = useState<string>(
    AspectRatio.AR_1_1,
  );
  const [divWidth, setDivWidth] = useState(
    document.getElementById('modal')?.offsetWidth || 0,
  );

  const onSelectDimension = (dimension: string) => {
    setCurrDimension(dimension);
    setDivWidth(document.getElementById('modal')?.offsetWidth || 0);
  };

  const { contentStudioEnableImageShare, enableSharing } = useFlagsCombination(
    userIdentity.currentRole,
  );

  const dimension = getShareableImageDimension(currDimension);
  const background = getPosterUrl(
    props.sharablePost.imagefile?.url || '',
    dimension.width!,
    dimension.height!,
    false,
  );

  const clip = {
    id: props.sharablePost.id,
    quote: props.sharablePost.quote,
    url: background,
    imageFile: props.sharablePost.imagefile,
    _allReferencingSharedContents:
      props.sharablePost._allReferencingSharedContents,
    _allReferencingCaptions: props.sharablePost._allReferencingCaptions,
  };

  const storytellerParts = (props.sharablePost.storytellerName || '')
    .split('|')
    .map(part => part.trim());
  const storytellerName = storytellerParts[0] || '';
  const organization = storytellerParts[1] || '';

  return (
    <ShareModal
      onClose={() => props.toggleShare(null)}
      shareableImageToggle={props.toggleShare}
      shareable={clip as ShareableImagePreviewType}
      selectedDimension={currDimension}
      hideShareButton={!contentStudioEnableImageShare}
      imageRef={imageRef}
    >
      <Main>
        <TopRow>
          {enableSharing && (
            <SocialShareStatus
              sharedContents={clip?._allReferencingSharedContents}
              isImage={true}
              showOnlyShared={true}
            />
          )}
          <Dimensions>
            <DimensionsSelector
              dimensions={Object.values(AspectRatio).map(aspectRatio => ({
                aspectRatio,
                isPublished: true,
              }))}
              selectedDimension={currDimension}
              onSelectDimension={onSelectDimension}
            />
          </Dimensions>
        </TopRow>
        <ContentArea>
          <ShareableImageView
            background={background}
            width={`${dimension.width / 2}px`}
            aspectRatio={currDimension.split(':').join('/')}
            imageRef={imageRef}
            quote={props.sharablePost.quote}
            storytellerName={storytellerName}
            organization={organization}
            divWidth={divWidth}
            setDivWidth={setDivWidth}
          />
        </ContentArea>
      </Main>
    </ShareModal>
  );
};

export default SharableImagesModalOLD;

const Main = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
`;

const TopRow = styled.div`
  display: flex;
  gap: 10px;
`;

const Dimensions = styled.div`
  margin-left: auto;
`;

const ContentArea = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  // width: 100%;
  // height: 100%;
`;
